export default {
  fromValue (val) {
    switch (val) {
      case 'legislation':
        return 'Legislação'
      case 'recycling':
        return 'Reciclagem'
      case 'acc':
        return 'Ciclomotor'
      case 'a':
        return 'Moto'
      case 'b':
        return 'Carro'
      case 'c':
        return 'Caminhão (C)'
      case 'd':
        return 'Ônibus (D)'
      case 'e':
        return 'Carreta (E)'
      default:
        return val
    }
  }
}
